import { useEffect, useMemo, useRef, useState } from "react";
import { Modal, Button, Slider, Spin, Form, notification, Switch } from "antd";
import { Modal as AntdModal } from "antd";
import {
  CloseOutlined,
  PlusOutlined,
  RedoOutlined,
  UndoOutlined,
  LoadingOutlined,
  InfoCircleOutlined,
  CloseCircleOutlined,
  DeleteOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
} from "@ant-design/icons";
import { Rnd } from "react-rnd";
import blue_4_6 from "./assets/blue_4_6.svg";
import grain_texture from "./assets/grain-texture.png";
import gray_4_6 from "./assets/gray_4_6.svg";
import blue_9_16 from "./assets/blue_9_16.svg";
import gray_9_16 from "./assets/gray_9_16.svg";
import blue_16_9 from "./assets/blue_16_9.svg";
import gray_16_9 from "./assets/gray_16_9.svg";
import "./ImageEditorModal.scss";
import parseMediaUrl from "../../../functions/parseMediaUrl";
import Functions from "./functions";
import _, { initial } from "lodash";
import LeftSideBar from "./LeftSidebar";
import CanvasEditor from "image-arts";
import {
  getEventFromMatchday,
  getEventFromMatchdayHeimspiel,
} from "../../../functions/getEventFromMatchday";
import splitFormValues from "../../../functions/splitFormValues";
import { useGlobalStore } from "../../../../../stores/globalBackendStore";
import { useTranslation } from "react-i18next";
import { InputMedia } from "../../Forms/Fields/types/_FormMedia";
import { InputSlide } from "../../Forms/Fields/types/_FormSlide";
import {
  createScreenshot,
  setTemplateById,
  uploadMedia,
} from "../../../../../services/backend/api.service";
import i18n from "../../../../../language";
import SaveModal from "./SaveModal";
import backendCfg from "../../../../../config/backend";
import useDebouncedResizeEffect from "./updateResizeHandler";
import { useLayerSignatureTracker } from "./detectChangedLayerSignature";
import FabricFromLayers from "./fabric";
import LayersList from "./draggableLayer";
import FabricCanvas from "./fabric";
const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms));
import LineupForEdit from "../../../../frontend/templates/fcb/LineupNew/LineupForEdit.jsx";
import { filteredTemplates } from "./LeftSidebar/TemplatesTab.js";
import FCBResultContent from "./resultContent.js";
import FCBHeatmapContent from "./heatmapContent.js";
import FCBGoalContent from './goalContent.js';
import FCBTableContent from './tableContent.js';

import { DEFAULT_ADJUSTMENTS, INITIAL_ADJUSTMENTS } from "../../../../frontend/constants/constants.js";
import { GKPresetColors, PresetColors, ResultTimes } from "./LeftSidebar/EditTab.js";
import ReactCrop from "react-image-crop";
import 'react-image-crop/dist/ReactCrop.css'
import FCBSlider1Content from "./slider1Content.js";
import FCBSlider2Content from "./slider2Content.js";
import {
  getSlider2FrameSize,
  getSlider2FrameStyle,
  getSlider2PictureClip,
  getSlider2PlateStyle,
  isSlider2Template,
} from "../../../../frontend/templates/fcb/MatchdaySlider2/frame";
import {
  getSlider2Background,
  getSlider2EdgeColor,
} from "../../../../frontend/templates/fcb/MatchdaySlider2/background";
import FCBSlider3Content from './slider3Content.js';
import FCBSlider4Content from './slider4Content.js';
import { uefaID } from "../../../../frontend/templates/fcb/ImageTable/Index.jsx";

const TABS = [
  {
    id: "light",
    title: "Light",
    adjustments: [
      { label: "Exposure", key: "exposure" },
      { label: "Contrast", key: "contrast" },
      { label: "Highlights", key: "highlight" },
      { label: "Shadows", key: "shadow" },
      { label: "Whites", key: "white" },
      { label: "Blacks", key: "black" },
    ],
  },
  {
    id: "effect",
    title: "Effect",
    adjustments: [
      { label: "Structure", key: "structure" },
      { label: "Clarity", key: "clarity" },
      { label: "Dehaze", key: "dehaze" },
      { label: "Vignette", key: "vignette" },
      { label: "Grain", key: "grain" },
    ],
  },
  {
    id: "color",
    title: "Color",
    adjustments: [
      { label: "Red", key: "red", color: "#e05d6f" },
      { label: "Orange", key: "orange", color: "#ed8936" },
      { label: "Yellow", key: "yellow", color: "#ecc94b" },
      { label: "Green", key: "green", color: "#48bb78" },
      { label: "Aquamarint", key: "aqua", color: "#38b2ac" },
      { label: "Blue", key: "blue", color: "#4299e1" },
      { label: "Purple", key: "purple", color: "#9f7aea" },
      { label: "Magenta", key: "magenta", color: "#ed64a6" },
    ],
  },
];

const adjustColor = {
  HSL: {
    Hue: [
      { label: "Red", key: "hsl_hue_red", color: "#e05d6f" },
      { label: "Orange", key: "hsl_hue_orange", color: "#ed8936" },
      { label: "Yellow", key: "hsl_hue_yellow", color: "#ecc94b" },
      { label: "Green", key: "hsl_hue_green", color: "#48bb78" },
      { label: "Aquamarine", key: "hsl_hue_aqua", color: "#38b2ac" },
      { label: "Blue", key: "hsl_hue_blue", color: "#4299e1" },
      { label: "Purple", key: "hsl_hue_purple", color: "#9f7aea" },
      { label: "Magenta", key: "hsl_hue_magenta", color: "#ed64a6" }
    ],
    Saturation: [
      { label: "Red", key: "hsl_saturation_red", color: "#e05d6f" },
      { label: "Orange", key: "hsl_saturation_orange", color: "#ed8936" },
      { label: "Yellow", key: "hsl_saturation_yellow", color: "#ecc94b" },
      { label: "Green", key: "hsl_saturation_green", color: "#48bb78" },
      { label: "Aquamarine", key: "hsl_saturation_aqua", color: "#38b2ac" },
      { label: "Blue", key: "hsl_saturation_blue", color: "#4299e1" },
      { label: "Purple", key: "hsl_saturation_purple", color: "#9f7aea" },
      { label: "Magenta", key: "hsl_saturation_magenta", color: "#ed64a6" }
    ],
    Luminance: [
      { label: "Red", key: "hsl_luminance_red", color: "#e05d6f" },
      { label: "Orange", key: "hsl_luminance_orange", color: "#ed8936" },
      { label: "Yellow", key: "hsl_luminance_yellow", color: "#ecc94b" },
      { label: "Green", key: "hsl_luminance_green", color: "#48bb78" },
      { label: "Aquamarine", key: "hsl_luminance_aqua", color: "#38b2ac" },
      { label: "Blue", key: "hsl_luminance_blue", color: "#4299e1" },
      { label: "Purple", key: "hsl_luminance_purple", color: "#9f7aea" },
      { label: "Magenta", key: "hsl_luminance_magenta", color: "#ed64a6" }
    ],
    All: [
      { label: "Hue Shift", key: "hsl_all_hue", color: "#888" },
      { label: "Saturation", key: "hsl_all_saturation", color: "#888" },
      { label: "Luminance", key: "hsl_all_luminance", color: "#888" },
    ]
  },
  RGB: [
    { label: "Red", key: "rgb_red", color: "#ff4d4f" },
    { label: "Green", key: "rgb_green", color: "#52c41a" },
    { label: "Blue", key: "rgb_blue", color: "#1890ff" }
  ]
};

function ColorMixerPanel({ colorMode, setColorMode, currentValues, onChange, isFcbTemplate, tab, collapsed, visible, toggleCollapse, toggleVisible }) {
  const [activeSubTab, setActiveSubTab] = useState("Hue");
  const isRGB = colorMode === "HSL";

  const renderSliderGroup = (group) => (
    adjustColor.HSL[group]?.map(({ label, key, color }) => (
      <div className="slider-color-row" key={key}>
        <div className="slider-label-row">
          <label className="slider-label">{label}</label>
          <input
            className="slider-value"
            type="number"
            min={-100}
            max={100}
            value={currentValues[key]}
            onChange={(e) => onChange(key, Number(e.target.value) || 0)}
            disabled={isFcbTemplate}
          />
        </div>
        <Slider
          className="custom-slider"
          min={-100}
          max={100}
          value={currentValues[key] || 0}
          onChange={(value) => onChange(key, value)}
          disabled={isFcbTemplate}
          // trackStyle={{ background: color || "#888", height: 4 }}

          trackStyle={{
            background: `linear-gradient(to right, ${color || "#888"}, #fff ${(100 || 0) + 100
              }%)`,
            height: 4,
          }}
          railStyle={{ background: "#333", height: 4 }}
          handleStyle={{ borderColor: "#fff", backgroundColor: "#fff" }}
        />
      </div>
    ))
  );

  return (
    <div className="adjustment-group">
      <div className="adjustment-group-header">
        <div className="adjustment-title-wrap">
          <button
            className="adjustment-toggle-button"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              // toggleCollapse();
            }}
          >
            <svg
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#ccc"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              style={{
                marginRight: 6,
                verticalAlign: 'middle',
                transform: collapsed ? 'rotate(0deg)' : 'rotate(180deg)',
                transition: 'transform 0.2s ease',
              }}
            >
              <polyline points="6 9 12 15 18 9" />
            </svg>
            {tab?.title || "Color"}
          </button>
        </div>
        <button
          className="adjustment-eye-button"
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            // toggleVisible();
          }}
        >
          {visible ? <EyeOutlined /> : <EyeInvisibleOutlined />}
        </button>
      </div>

      {!collapsed && visible && (
        <>
          {/* <div className="color-mixer-tabs">
            <span className="active-tab">Mixer</span>
            <span className="disabled-tab">Point Color</span>
          </div> */}

          <div className="color-mode-select">
            <label className="dropdown-label">Adjust</label>
            <select value={colorMode} onChange={(e) => setColorMode(e.target.value)}>
              <option value="HSL">HSL</option>
              <option value="RGB">RGB</option>
            </select>
            <div className="color-mode-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                viewBox="0 0 30 24"
                fill="none"
                stroke="#ccc"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
                focusable="false"
              >
                {/* Plus sign */}
                <line x1="6" y1="2" x2="6" y2="10" />
                <line x1="2" y1="6" x2="10" y2="6" />

                {/* Outer circle */}
                <circle cx="17" cy="17" r="7" />

                {/* Inner filled dot */}
                <circle cx="17" cy="17" r="1" fill="#ccc" />
              </svg>
            </div>
          </div>

          {colorMode === "HSL" && (
            <div className="sub-tabs">
              {Object.keys(adjustColor.HSL).map((tab) => (
                <span
                  key={tab}
                  className={tab === activeSubTab ? "active-tab" : ""}
                  onClick={() => setActiveSubTab(tab)}
                >
                  {tab}
                </span>
              ))}
            </div>
          )}

          <div className="adjustment-sliders">
            {!isRGB
              ? adjustColor.RGB.map(({ label, key, color }) => (
                <div className="slider-color-row" key={key}>
                  <div className="slider-label-row">
                    <label className="slider-label">{label}</label>
                    <input
                      className="slider-value"
                      type="number"
                      min={-100}
                      max={100}
                      value={currentValues[key] || 0}
                      onChange={(e) => onChange(key, Number(e.target.value) || 0)}
                      disabled={isFcbTemplate}
                    />
                  </div>
                  <Slider
                    className="custom-slider"
                    min={-100}
                    max={100}
                    value={currentValues[key] || 0}
                    onChange={(value) => onChange(key, value)}
                    disabled={isFcbTemplate}
                    // trackStyle={{ background: color, height: 4 }}
                    trackStyle={{
                      background: `linear-gradient(to right, ${color || "#888"}, #fff ${(100 || 0) + 100
                        }%)`,
                      height: 4,
                    }}
                    railStyle={{ background: "#333", height: 4 }}
                    handleStyle={{ borderColor: "#fff", backgroundColor: "#fff" }}
                  />
                </div>
              ))
              : renderSliderGroup(activeSubTab)}
          </div>
        </>
      )}
    </div>
  );
}

export const aspectRatios = [
  {
    label: `16:9`,
    url: gray_16_9,
    selectedUrl: blue_16_9,
    ratio: 1.78,
    format: "1920x1080"
  },
  {
    label: `9:16`,
    url: gray_9_16,
    selectedUrl: blue_9_16,
    ratio: 0.56,
    format: "1080x1920"
  },
  {
    label: `4:5`,
    url: gray_4_6,
    selectedUrl: blue_4_6,
    ratio: 0.8,
    format: "1200x1500"
  },
];

export const cropButtons = [
  {
    label: `Crop`,
    url: gray_4_6,
    selectedUrl: blue_4_6,
  },
  {
    label: `Resize`,
    url: gray_4_6,
    selectedUrl: blue_4_6,
  },
];

export const MAX_WIDTH = 344.5; // 275.6; // 344.5;
export const MAX_HEIGHT = 613.6; // 490.88; // 613.6;

export const getWrapperDimensions = (targetRatio) => {
  switch (targetRatio) {
    case 1.78: {
      return {
        width: MAX_HEIGHT,
        height: MAX_WIDTH
      }
    }
    case 0.56: {
      return {
        width: MAX_WIDTH,
        height: MAX_HEIGHT
      }
    }
    case 0.8: {
      return {
        width: MAX_HEIGHT * 0.8,
        height: MAX_HEIGHT
      }
    }

    default: {
      return {
        width: MAX_WIDTH,
        height: MAX_HEIGHT
      }
    }
  }
}

export const getImageFilterStyle = (adjustments = {}) => {
  const {
    brightness = 0,
    contrast = 0,
    highlight = 0,
    shadow = 0,
    exposure = 0,
    white = 0,
    black = 0,
    saturation = 0,
    warmth = 0,
    blur = 0,
    structure = 0,
    clarity = 0,
    dehaze = 0,
    vignette = 0,
    grain = 0,

    hsl_all_hue = 0,
    hsl_all_saturation = 0,
    hsl_all_luminance = 0,

    // RGB
    rgb_red = 0,
    rgb_green = 0,
    rgb_blue = 0,
  } = adjustments;

  const filterParts = [];

  // --- Base Filter Effects ---
  filterParts.push(`brightness(${1 + brightness / 100})`);
  filterParts.push(`contrast(${1 + contrast / 100})`);
  filterParts.push(`saturate(${1 + saturation / 100})`);

  if (warmth !== 0) {
    const sepia = Math.min(Math.abs(warmth) / 100, 1);
    const hue = warmth > 0 ? 10 : -10;
    filterParts.push(`sepia(${sepia})`);
    filterParts.push(`hue-rotate(${hue}deg)`);
  }

  if (exposure !== 0) {
    filterParts.push(`brightness(${1 + exposure / 100})`);
    filterParts.push(`contrast(${1 + exposure / 200})`);
  }

  if (white !== 0) {
    filterParts.push(`contrast(${1 + white / 300})`);
    filterParts.push(`brightness(${1 + white / 150})`);
  }

  if (black !== 0) {
    filterParts.push(`brightness(${1 - black / 100})`);
  }

  if (highlight !== 0) {
    filterParts.push(`contrast(${1 + highlight / 200})`);
    filterParts.push(`brightness(${1 + highlight / 200})`);
  }

  if (structure !== 0) {
    filterParts.push(`contrast(${1 + structure / 300})`);
  }

  if (clarity !== 0) {
    const clarityContrast = 1 + clarity / 300;
    const claritySharpness = clarity > 0 ? `blur(${(20 - clarity) / 20}px)` : '';
    filterParts.push(`contrast(${clarityContrast})`);
    if (clarity > 0) filterParts.push(claritySharpness);
  }

  if (dehaze !== 0) {
    const hazeBright = 1 - dehaze / 300;
    const hazeContrast = 1 + dehaze / 200;
    filterParts.push(`brightness(${hazeBright})`);
    filterParts.push(`contrast(${hazeContrast})`);
  }

  if (blur !== 0) {
    filterParts.push(`blur(${Math.abs(blur / 10)}px)`);
  }

  const vignetteStyle = vignette !== 0 ? {
    boxShadow: `inset 0 0 ${Math.abs(vignette)}px rgba(0,0,0,${Math.min(Math.abs(vignette) / 100, 0.6)})`,
  } : {};

  const grainStyle = grain > 0 ? {
    backgroundImage: grain_texture,
    opacity: Math.min(grain / 100, 0.4),
    mixBlendMode: "overlay",
    pointerEvents: "none",
  } : {};

  const dropShadowFilter = `drop-shadow(0 ${shadow > 0 ? 4 : 0}px ${Math.min(Math.abs(shadow), 100) / 5}px rgba(0, 0, 0, ${Math.min(0.4, Math.abs(shadow) / 200)}))`;

  const hueKeys = [
    { key: "red", hue: 0 },
    { key: "orange", hue: 30 },
    { key: "yellow", hue: 60 },
    { key: "green", hue: 120 },
    { key: "aqua", hue: 180 },       // cyan
    { key: "blue", hue: 240 },
    { key: "purple", hue: 270 },     // violet
    { key: "magenta", hue: 300 },    // pink/magenta
  ];

  const colorOverlays = [];

  const addOverlay = (hue, value, blendMode) => {
    if (!value) return;

    let backgroundColor = "";
    let opacity = Math.min(Math.abs(value) / 100, 0.5);

    if (blendMode === "hue") {
      const adjustedHue = (hue + value + 360) % 360;
      backgroundColor = `hsl(${adjustedHue}, 100%, 50%)`;
    }

    else if (blendMode === "saturation") {
      if (value > 0) {
        // Intensify the specific tone
        backgroundColor = `hsl(${hue}, 100%, 50%)`; // pure tone
      } else {
        // Desaturate the tone using grayscale + slight hue shift
        const shiftedHue = (hue + 180) % 360;
        backgroundColor = `hsl(${shiftedHue}, 0%, 50%)`; // neutralize
      }
    }

    else if (blendMode === "luminosity") {
      if (value > 0) {
        backgroundColor = `hsl(${hue}, 100%, 90%)`;
        blendMode = "screen";
      } else {
        backgroundColor = `hsl(${hue}, 100%, 10%)`;
        blendMode = "multiply";
      }
    }

    colorOverlays.push({
      mixBlendMode: blendMode,
      backgroundColor,
      opacity,
    });
  };


  hueKeys.forEach(({ key, hue }) => {
    addOverlay(hue, adjustments[key], "hue"); // legacy tone
    addOverlay(hue, adjustments[`hsl_hue_${key}`], "hue");
    addOverlay(hue, adjustments[`hsl_saturation_${key}`], "saturation");
    addOverlay(hue, adjustments[`hsl_luminance_${key}`], "luminosity");
  });

  // RGB simulated overlays (using opposite hues for negative values)
  if (rgb_red !== 0) {
    const hue = rgb_red > 0 ? 0 : 180;
    colorOverlays.push({
      mixBlendMode: "screen",
      backgroundColor: `hsl(${hue}, 100%, 50%)`,
      opacity: Math.min(Math.abs(rgb_red) / 100, 0.5),
    });
  }
  if (rgb_green !== 0) {
    const hue = rgb_green > 0 ? 120 : 300;
    colorOverlays.push({
      mixBlendMode: "screen",
      backgroundColor: `hsl(${hue}, 100%, 50%)`,
      opacity: Math.min(Math.abs(rgb_green) / 100, 0.5),
    });
  }
  if (rgb_blue !== 0) {
    const hue = rgb_blue > 0 ? 240 : 60;
    colorOverlays.push({
      mixBlendMode: "screen",
      backgroundColor: `hsl(${hue}, 100%, 50%)`,
      opacity: Math.min(Math.abs(rgb_blue) / 100, 0.5),
    });
  }

  if (hsl_all_hue !== 0) {
    colorOverlays.push({
      mixBlendMode: "hue",
      backgroundColor: `hsl(${(hsl_all_hue + 360) % 360}, 100%, 50%)`,
      opacity: Math.min(Math.abs(hsl_all_hue) / 100, 0.5),
    });
  }

  // All Saturation
  if (hsl_all_saturation !== 0) {
    if (hsl_all_saturation > 0) {
      colorOverlays.push({
        mixBlendMode: "saturation",
        backgroundColor: `hsl(0, 100%, 50%)`,
        opacity: Math.min(hsl_all_saturation / 100, 0.5),
      });
    } else {
      colorOverlays.push({
        mixBlendMode: "color",
        backgroundColor: `hsl(0, 0%, 50%)`, // neutral gray to desaturate
        opacity: Math.min(Math.abs(hsl_all_saturation) / 100, 0.5),
      });
    }
  }

  // All Luminance
  if (hsl_all_luminance !== 0) {
    const bgColor =
      hsl_all_luminance > 0
        ? `hsl(0, 0%, 90%)` // light tone to brighten
        : `hsl(0, 0%, 10%)`; // dark tone to darken

    colorOverlays.push({
      mixBlendMode: "luminosity",
      backgroundColor: bgColor,
      opacity: Math.min(Math.abs(hsl_all_luminance) / 100, 0.5),
    });
  }

  return {
    filter: `${dropShadowFilter} ${filterParts.join(" ")}`,
    ...vignetteStyle,
    ...grainStyle,
    colorOverlays,
  };
};

const trimTransparentEdges = async (image) => {
  return new Promise((resolve) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    canvas.width = image.width;
    canvas.height = image.height;

    ctx.drawImage(image, 0, 0);

    const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const pixels = imgData.data;

    let top = null, bottom = null, left = null, right = null;

    for (let y = 0; y < canvas.height; y++) {
      for (let x = 0; x < canvas.width; x++) {
        const idx = (y * canvas.width + x) * 4;
        if (pixels[idx + 3] > 0) {
          if (top === null) top = y;
          bottom = y;
          if (left === null || x < left) left = x;
          if (right === null || x > right) right = x;
        }
      }
    }

    if (top !== null) {
      const trimmedWidth = right - left + 1;
      const trimmedHeight = bottom - top + 1;
      const trimmedCanvas = document.createElement("canvas");
      const trimmedCtx = trimmedCanvas.getContext("2d");

      trimmedCanvas.width = trimmedWidth;
      trimmedCanvas.height = trimmedHeight;

      trimmedCtx.drawImage(canvas, left, top, trimmedWidth, trimmedHeight, 0, 0, trimmedWidth, trimmedHeight);

      resolve(trimmedCanvas);
    } else {
      // Entirely transparent image, return original canvas
      resolve(canvas);
    }
  });
}

const AdjustmentPanel = ({ tab, collapsed, visible, toggleCollapse, toggleVisible, currentValues, onChange, isFcbTemplate }) => (
  <div className="adjustment-group">
    <div className="adjustment-group-header">
      <div className="adjustment-title-wrap">
        {/* <button className="adjustment-toggle-button" onClick={toggleCollapse}> */}
        <button
          className="adjustment-toggle-button"
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            // toggleCollapse();
          }}
        >
          <svg
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#ccc"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{
              marginRight: 6,
              verticalAlign: 'middle',
              transform: collapsed ? 'rotate(0deg)' : 'rotate(180deg)',
              transition: 'transform 0.2s ease',
            }}
          >
            <polyline points="6 9 12 15 18 9" />
          </svg>
          {tab.title}
        </button>
        {/* <h5 className="adjustment-group-title">{tab.title}</h5> */}
      </div>
      {/* <button className="adjustment-eye-button" onClick={toggleVisible}> */}
      <button
        className="adjustment-eye-button"
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          // toggleVisible();
        }}
      >
        {visible ? <EyeOutlined /> : <EyeInvisibleOutlined />}
      </button>
    </div>

    {!collapsed && visible && (
      <div className="adjustment-sliders">
        {tab.adjustments.map(({ label, key, color }) => (
          <div className="slider-row" key={key}>
            <div className="slider-label-row">
              <label className="slider-label">
                {label} <InfoCircleOutlined />
              </label>
              <input
                className="slider-value"
                type="number"
                min={-100}
                max={100}
                value={currentValues[key]}
                onChange={(e) => onChange(key, Number(e.target.value) || 0)}
                disabled={isFcbTemplate}
              />
            </div>

            <Slider
              className="custom-slider"
              min={-100}
              max={100}
              step={1}
              value={currentValues[key]}
              onChange={(value) => onChange(key, value)}
              disabled={isFcbTemplate}
              trackStyle={{
                background: `linear-gradient(to right, #555, #fff ${(100 || 0)
                  }%)`,
                height: 4,
              }}
              // trackStyle={{
              //   background: color || "#888",
              //   height: 4,
              // }}
              railStyle={{
                background: "#333",
                height: 4,
              }}
              handleStyle={{
                borderColor: "#fff",
                backgroundColor: "#fff",
              }}
            />
          </div>
        ))}
      </div>
    )}
  </div>
);

// const initialImageUrl = `https://res.cloudinary.com/donklmnnv/image/upload/v1745833900/lineup_dezdfh.jpg`;
const ImageEditorModal = ({ open, onClose, template, previewFormat }) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const [visibleEdit, setVisibleEdit] = useState(false);

  const [isAPICallCalling, setIsAPICallCalling] = useState(false);
  const [loading, setLoading] = useState(false);
  const [templateData, setTemplateData] = useState({});
  const [originTemplateData, setOriginTemplateData] = useState({});
  const [newStylingData, setNewStylingData] = useState({});
  const [undoStack, setUndoStack] = useState([]);
  const [redoStack, setRedoStack] = useState([]);
  const [activeTab, setActiveTab] = useState("Edit");
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [showSaveModal, setShowSaveModal] = useState(false);
  const { options, fields } = templateData?.data || {};
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [selectedRatio, setSelectedRatio] = useState(0);
  const templateLan = template?.lang;
  const [selectedLangs, setSelectedLangs] = useState([templateLan]);
  const [selectedFormats, setSelectedFormats] = useState([]);
  const isFcbTemplate = template?.template_name === "fcb_lineup";

  // Whether the canvas is drawing fcb_matchday_slider_2.
  //
  // Deliberately NOT `selectedTemplate`: that is the Templates-tab choice,
  // which starts as "" and only fills in once someone clicks a template in the
  // sidebar -- so keying the frame off it left the picture full bleed until
  // they did. `templateData` carries the template being edited from the moment
  // the modal opens, and the tab swaps it when a different template is picked,
  // so it reads correctly both before and after a selection.
  const isSlider2 = isSlider2Template(
    templateData?.template_name || template?.template_name,
  );

  // Whether the canvas is drawing fcb_matchday_slider_4. Read off the same
  // source as `isSlider2` -- and for the same reason -- because it gates the
  // CL/Pokal switches, which have to be on the sidebar from the moment the
  // modal opens rather than only after someone re-picks the template.
  const isSlider4 =
    (templateData?.template_name || template?.template_name) ===
    "fcb_matchday_slider_4";

  // Same again for fcb_matchday_slider_1, and for the same reason: it gates the
  // CL/Pokal switches, which have to be on the sidebar from the moment the
  // modal opens rather than only after someone re-picks the template.
  const isSlider1 =
    (templateData?.template_name || template?.template_name) ===
    "fcb_matchday_slider_1";

  // Keyed off `selectedTemplate` rather than the template name, because it has
  // to flip in step with the FCBResultContent preview below — that is what
  // paints the frame-wide scrim once the per-layer ones are dropped, and it is
  // gated on the same value.
  const isResults = selectedTemplate === "fcb_results" || selectedTemplate === "womens_results" || selectedTemplate === "juniors_results";

  // Where a freshly added layer starts out. Every template but
  // fcb_matchday_slider_2 uses its picture as a full-bleed background, so the
  // layer is the whole canvas; on slider 2 the picture is a framed box in the
  // middle of the page, and a layer that has not been touched yet should come
  // up filling that box instead of being cropped to a fraction of itself.
  const getNewLayerDimensions = () => {
    const canvas = getWrapperDimensions(effects?.ratio);
    return isSlider2 ? getSlider2FrameSize(canvas) : canvas;
  };

  // The frame's corner bevels and edge are cut in template pixels, so drawing
  // them on a canvas a third of that size means scaling them by the same
  // factor the canvas is at.
  const slider2Scale = () => {
    const templateWidth = Number(updatedFormat?.split("x")[0]);
    if (!templateWidth || !screenSize?.width) return 1;
    return screenSize.width / templateWidth;
  };

  // The layers are drawn straight onto the canvas for every template except
  // slider 2, which frames them -- so only that one gets a wrapper and every
  // other template's tree is left exactly as it was.
  const frameLayers = (layerBoxes) =>
    isSlider2 ? (
      <div className="slider2-image-frame" style={getSlider2FrameStyle({ clip: false })}>
        {/* The edge, as a plate the picture is inset from. It is a child here
            rather than a background with a clip-path on the frame itself,
            because clipping the frame would clip the layers' drag handles
            with it -- the same reason the frame is built with clip: false. */}
        <div
          className="slider2-image-frame-plate"
          style={{
            ...getSlider2PlateStyle(slider2Scale()),
            background: getSlider2EdgeColor({
              jersey: effects?.jersey,
              hasCLStars: effects?.hasCLStars,
              isDfbPokal: effects?.isDfbPokal,
            }),
          }}
        />
        {layerBoxes}
      </div>
    ) : (
      layerBoxes
    );
  const [presetBgColor, setPresetBgColor] = useState("#363d43");
  const [presetGkColor, setPresetGkColor] = useState("");
  const [cropOption, setCropOption] = useState(cropButtons[1].label)
  const selectedMatchday = useGlobalStore((state) => state.selectedMatchday);
  const apiSetup = useGlobalStore((state) => state.apiSetup);
  const templatesSetup = _.get(apiSetup, `templates`, []);
  const templateFormats = _.get(
    _.find(templatesSetup, { name: templateData?.template_name }),
    "formats",
    [],
  );

  const [manualEntries, setManualEntries] = useState(null);

  const backgroundUrls = useMemo(() => {
    const values = _.get(templateData, "data.fields[0].value", []);
    if (!Array.isArray(values)) return [];
    return values.map((val) => parseMediaUrl(_.get(val, "url", "")));
  }, [templateData, selectedTemplate]);

  const functionCallback = async (asyncFn) => {
    try {
      return await asyncFn();
    } finally {
    }
  };

  const [layers, setLayers] = useState([]);
  const [currentLayerId, setCurrentLayerId] = useState(0);
  // Pre-drag {layers, effects} for the gradient-height slider; see setScrimHeight.
  const scrimHeightUndoRef = useRef(null);
  const layersRef = useRef([]);
  const prevLayerSignatureRef = useRef([]);
  const prevLayersRef = useRef([]);
  const initialLayersLoaded = useRef(false);
  const previousTemplateRef = useRef(null);
  const prevRatioRef = useRef(null);
  useEffect(() => {
    layersRef.current = layers; // Keep reference to latest layers
  }, [layers]);

  // Whether smiling photos are allowed by default is driven by the actual
  // match's competition (UEFA), not by the "Has CL stars" switch — that's a
  // separate, manually-controlled cosmetic effect.
  const isUEFAMatch = templateData?.event?.competitionId === uefaID;
  const defaultEffects = {
    isBlur: false,
    isOpacity: false,
    isGradient: false,
    isShadow: false,
    resize: 100,
    ratio: 0.56,
    ratioUrl: "",
    prevRatio: 0.56,
    gkPreset: GKPresetColors.red,
    hasCLStars: false,
    isDfbPokal: false,
    includeSmiling: !isUEFAMatch,
    cropOption: cropButtons[1].label,
    jersey: PresetColors.white,
    time: ResultTimes.halfTime,
    isPenalty: false,
  }
  const [effects, setEffects] = useState(null);
  const [undo, setUndo] = useState(false);
  const [loadingFormat, setLoadingFormat] = useState(true);
  //add this part for updated right panel
  const [isLightCollapsed, setIsLightCollapsed] = useState(false);
  const [isLightVisible, setIsLightVisible] = useState(true);
  const [isColorCollapsed, setIsColorCollapsed] = useState(false);
  const [isColorVisible, setIsColorVisible] = useState(true);
  const [isEffectCollapsed, setIsEffectCollapsed] = useState(false);
  const [isEffectVisible, setIsEffectVisible] = useState(true);
  const [activeRightSideBarTab, setActiveRightSideBarTab] = useState("light");
  const [collapsed, setCollapsed] = useState({ light: false, effect: false, color: false });
  const [visible, setVisible] = useState({ light: true, effect: true, color: true });
  const [colorMode, setColorMode] = useState("RGB");


  const handleClose = () => {
    if (hasUnsavedChanges) {
      console.log('Unsaved changes Detected ')
      AntdModal.confirm({
        title: "Unsaved Changes",
        content: "Are you sure you want to close without saving?",
        okText: "Yes, Close",
        okType: "danger",
        cancelText: "No",
        onOk() {
          setHasUnsavedChanges(false);
          resetRefs();
          onClose(); // actually close the modal
        },
        cancelButtonProps: {
          type: "primary", // Makes it a filled primary button
        },
      });
    } else {
      console.log('No Unsaved changes Detected ')
      resetRefs();
      onClose();
    }
  };

  async function handleCreateScreenshot(templateDataRes, templateData, selectedFormats, effects, backendCfg, t, i18n) {
    const lang = templateDataRes?.lang || 'en';
    const serverTemplateUuid = templateDataRes?.uuid || null;
    const buildActionsForFormats = [];
    const format = templateDataRes.currentFormat;
    buildActionsForFormats.push({
      templateId: serverTemplateUuid,
      url: `${backendCfg.frontendUrl}/screenshot/${templateData?.template_name}/${serverTemplateUuid}?format=${format}`,
      dir: templateData.template_name,
      format,
      preview: true,
      ratio: effects?.ratio,
    });

    try {
      await createScreenshot({
        id: templateData.uuid,
        template_name: templateData.template_name,
        actions: buildActionsForFormats,
      });

      notification.success({
        message: t("Success"),
        description: t("Template screenshot updated."),
        placement: "topRight",
      });
    } catch (err) {
      notification.error({
        message: i18n.t("Screenshot error"),
        description: err?.response?.data?.errors?.msg || 'Unknown error',
      });
    }
  }

  function chunkArray(array, size) {
    const result = [];
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  }

  const onFinish = async () => {
    const lineupData = fields?.find((field) => field?.id === 'lineup_players');
    const parsedValues = splitFormValues(
      form.getFieldValue(),
      { fields, options },
      { updatedStyles: newStylingData },
      { updateData: true, updatedData: lineupData?.data }
    );
    parsedValues.editData = {
      layers: layers,
      effects: effects,
      manualEntries: manualEntries
    };
    if (selectedMatchday?.feedType === "heimspiel") {
      parsedValues.selectedMatchday =
        getEventFromMatchdayHeimspiel(selectedMatchday);
    } else {
      parsedValues.selectedMatchday = getEventFromMatchday(selectedMatchday);
    }

    parsedValues.langs = selectedLangs;
    parsedValues.selectedFormats = selectedFormats;
    parsedValues.skipScreenshot = true;
    if (templateData.template_name === 'fcb_goal') {
      parsedValues.currentGoalId = templateData?.data?.updater?.id;
    }
    // parsedValues.currentFormat = templateData?.currentFormat;
    const templateDataResponse = await setTemplateById({
      id: templateData.uuid,
      template_name: templateData.template_name,
      data: parsedValues,
    }).catch((err) => {
      notification["error"]({
        message: t("Template saving error"),
        description: err.message,
        placement: "topRight",
      });
    });

    notification["success"]({
      message: t("Success"),
      description: t("Template data has been saved."),
      placement: "topRight",
    });
    const responseData = templateDataResponse.data;
    const chunkSize = 5; // number of parallel requests per batch
    const chunks = chunkArray(responseData, chunkSize);

    for (const batch of chunks) {
      await Promise.all(
        batch.map((templateDataRes) =>
          handleCreateScreenshot(templateDataRes, templateData, templateFormats, effects, backendCfg, t, i18n)
        )
      );
    }
  };

  const setCurrentTemplateDataDebounced = useRef(
    _.debounce((templateData) => {
      setTemplateData({ ...templateData });
    }, 500),
  );

  const onValuesChange = (formData) => {
    const fields = [...templateData.data.fields];
    const formDataKeys = Object.keys(formData);
    const formDataKey = formDataKeys?.[0];
    const MAX_PLAYERS = 11;
    const SUB_MAX_PLAYERS = 15;
    setHasUnsavedChanges(true);
    // Check and limit lineup_players if needed
    if (
      formData.lineup_players &&
      formData.lineup_players.length > MAX_PLAYERS
    ) {
      formData.lineup_players = formData.lineup_players.slice(0, MAX_PLAYERS);
    }

    // Check and limit reserve_players if needed
    if (
      formData.reserve_players &&
      formData.reserve_players.length > SUB_MAX_PLAYERS
    ) {
      formData.reserve_players = formData.reserve_players.slice(0, SUB_MAX_PLAYERS);
    }

    fields.forEach((item) => {
      const value = _.get(formData, item.id, null);
      if (value !== null) {
        if (
          (item.id === "lineup_players" || item.id === "reserve_players") &&
          Array.isArray(value)
        ) {
          let max = item.id === "lineup_players" ? MAX_PLAYERS : SUB_MAX_PLAYERS;
          item.value = value.slice(0, max);
        } else if (item.id === 'heatmap_players') {
          item.value = value[value.length - 1];
        } else {
          item.value = value;
        }
      }

      return item;
    });
    if (formDataKey !== "lineup_players" && formDataKey !== "reserve_players" && formDataKey !== "heatmap_players") {
      setCurrentTemplateDataDebounced.current(templateData);
    }
    setLoadingFormat(false);
  };

  useEffect(() => {
    if (loadingFormat) {
      const timer = setTimeout(() => {
        setLoadingFormat(false);
      }, 2000); // fallback to stop loading after 2s
      return () => clearTimeout(timer);
    }
  }, [loadingFormat]);

  const updateWithUndo = async (newState, type) => {
    setHasUnsavedChanges(true);
    const currentState = {
      layers: _.cloneDeep(layers),
      effects: _.cloneDeep(effects),
    };
    setUndoStack((prev) => [...prev, currentState]);
    setRedoStack([]);
    if (type === "adjustments") {
      setLayers(prev => [...newState]); // Ensures a new array reference
    } else if (type === "backgroundAndResize") {
      updateBackgroundAndResize({ ...newState });
    } else if (type === "effects") {
      setUndo(false);
      // Only for Line up set loading format to true
      if (template.template_name === "fcb_lineup") {
        setLoadingFormat(true);
      }
      setEffects({ ...newState });
      // change 
    } else {
      // setLayers(prev => [...newState]); // Ensures a new array reference
    }

  };

  const updateBackgroundAndResize = (updates) => {
    setLayers(prev => {
      const updated = prev.map((layer, index) =>
        index === currentLayerId
          ? {
            ...layer,
            backgroundAndResize: {
              ...layer.backgroundAndResize,
              ...updates,
            },
          }
          : layer
      );
      return updated;
    });
  };

  const handleUndo = () => {
    if (undoStack.length === 0) return;

    const prevState = undoStack[undoStack.length - 1];
    const newUndoStack = undoStack.slice(0, -1);
    const currentState = {
      layers: _.cloneDeep(layers),
      effects: _.cloneDeep(effects)
    };

    setLoadingFormat(true);
    setUndoStack(newUndoStack);
    setRedoStack((prev) => [...prev, currentState]);
    setUndo(true);
    setLayers(prevState.layers);
    setEffects(prevState.effects);
    prevRatioRef.current = prevState.effects?.ratio;
  };

  const handleRedo = () => {
    if (redoStack.length === 0) return;
    setUndo(true)
    const nextState = redoStack[redoStack.length - 1];
    const newRedoStack = redoStack.slice(0, -1);
    const currentState = {
      layers: _.cloneDeep(layers),
      effects: _.cloneDeep(effects)
    };
    setLoadingFormat(true);

    setRedoStack(newRedoStack);
    setUndoStack((prev) => [...prev, currentState]);

    setLayers(nextState.layers);
    setEffects(nextState.effects);
    prevRatioRef.current = nextState.effects?.ratio;
  };

  const handleReset = () => {
    const defaultAdjustments = {
      brightness: 0,
      contrast: 0,
      highlight: 0,
      shadow: 0,
      saturation: 0,
      warmth: 0,
      blur: 0,
      exposure: 0,
      white: 0,
      black: 0,
      structure: 0,
      clarity: 0,
      dehaze: 0,
      vignette: 0,
      grain: 0,
      red: 0,
      orange: 0,
      yellow: 0,
      green: 0,
      aqua: 0,
      blue: 0,
      purple: 0,
      magenta: 0,

      hsl_hue_red: 0,
      hsl_hue_orange: 0,
      hsl_hue_yellow: 0,
      hsl_hue_green: 0,
      hsl_hue_aqua: 0,
      hsl_hue_blue: 0,
      hsl_hue_purple: 0,
      hsl_hue_magenta: 0,
      hsl_saturation_red: 0,
      hsl_saturation_orange: 0,
      hsl_saturation_yellow: 0,
      hsl_saturation_green: 0,
      hsl_saturation_aqua: 0,
      hsl_saturation_blue: 0,
      hsl_saturation_purple: 0,
      hsl_saturation_magenta: 0,
      hsl_luminance_red: 0,
      hsl_luminance_orange: 0,
      hsl_luminance_yellow: 0,
      hsl_luminance_green: 0,
      hsl_luminance_aqua: 0,
      hsl_luminance_blue: 0,
      hsl_luminance_purple: 0,
      hsl_luminance_magenta: 0,
      hsl_all_hue: 0,
      hsl_all_saturation: 0,
      hsl_all_luminance: 0,
      rgb_red: 0,
      rgb_green: 0,
      rgb_blue: 0,
    };

    const defaultBackgroundAndResize = {
      removebg: false,
      removebgUrl: "",
      changebg: false,
      changebgUrl: "",
      resize: 100,
      ratio: 0,
      ratioUrl: "",
    };

    setLayers(prevLayers =>
      prevLayers.map(layer => ({
        ...layer,
        adjustments: { ...defaultAdjustments },
        backgroundAndResize: { ...defaultBackgroundAndResize },
      }))
    );

    setUndoStack([]);
    setRedoStack([]);
    form.resetFields();
  };

  useEffect(() => {
    const isEmpty = !template || Object.keys(template).length === 0;
    setLoading(isEmpty);

    if (!isEmpty) {
      setTemplateData(template);
      if (template?.lang) {
        setSelectedLangs([template?.lang])
      }
      setOriginTemplateData(template)
      // only for lineup
      if (template.template_name === "fcb_lineup") {
        setSelectedTemplate(template)
      }
    }
  }, [template]);

  const resetRefs = () => {
    initialLayersLoaded.current = false;
    layersRef.current = [];
    previousTemplateRef.current = null;
    prevLayerSignatureRef.current = [];
    prevLayersRef.current = [];
    prevRatioRef.current = null;
    setEffects(defaultEffects)
  }

  const getFormatFromRatio = (ratio) => {
    let _format = '1080x1920';
    if (ratio === 1.78) _format = '1920x1080';
    if (ratio === 0.8) _format = '1200x1500';
    return _format;
  }

  useEffect(() => {
    // reset refs
    if (templateData?.selectFromTemplates) return;
    const newId = templateData?.uuid;
    if (newId) {
      const prevUuid = previousTemplateRef.current;
      if (!prevUuid) {
        previousTemplateRef.current = newId;
      } else if (prevUuid !== newId) {
        resetRefs();
        previousTemplateRef.current = newId;
      }
    }

    if (!templateData?.data) return;
    const initialValues = {};
    const newStylingData = {};
    if (templateData?.data?.fields?.length > 0) {
      templateData.data.fields.forEach((item) => {
        initialValues[item.id] = item.value;
      });

      templateData.data.fields.map((elem) => {
        if (!newStylingData?.[`${elem.id}`]) {
          _.set(newStylingData, `${elem.id}`, elem?.styles || {});
        }
      });

      setNewStylingData({
        ...newStylingData,
      });
    }
    const initialLayers = templateData?.data?.editData?.layers;
    const initialEffects = templateData?.data?.editData?.effects;
    const initialManualEntries = templateData?.data?.editData?.manualEntries;
    if (initialLayers && !initialLayersLoaded.current) {
      setLoadingFormat(true);
      setTimeout(() => {
        setLayers(initialLayers);
        setCurrentLayerId(initialLayers?.length > 0 ? initialLayers?.length - 1 : 0);
        // extract preset from initialLayers;
        // see if isPreset exist
        const presetLayer = initialLayers.find((layer) => layer.isPreset === true);
        if (presetLayer) {
          setPresetBgColor(presetLayer?.backgroundUrl);
        }
        if (initialEffects) {
          setPresetGkColor(initialEffects?.gkPreset);
        }
        // Only fall back to the isUEFAMatch-derived default when this
        // template has never had includeSmiling saved before (e.g. it
        // predates this feature). Once a user has explicitly set and saved
        // it, that choice should stick on reload rather than being
        // silently overwritten every time.
        setEffects(
          initialEffects
            ? { ...initialEffects, includeSmiling: initialEffects.includeSmiling ?? !isUEFAMatch }
            : defaultEffects
        );
        setManualEntries(initialManualEntries ?? null)
        if (initialEffects?.ratio > 0) {
          prevRatioRef.current = initialEffects?.ratio;

          setSelectedFormats([getFormatFromRatio(initialEffects?.ratio)]);
        } else {
          prevRatioRef.current = 0.56; // default
        }
        initialLayersLoaded.current = true;
      }, 300);

    }
    if (layersRef.current.length === 0 && !templateData?.data?.editData) {
      setLoadingFormat(true);
      const getBackgroundUrls = () => {
        const values = _.get(templateData, "data.fields[0].value", []);
        if (!Array.isArray(values)) return [];

        return values.map((val) => parseMediaUrl(_.get(val, "url", "")));
      }
      const backgroundUrls = getBackgroundUrls();

      // change default value of adjustments 
      const initializeLayers = async () => {
        const newLayerPromises = backgroundUrls.map(async (url, index) => {
          const functions = new Functions(url);
          const finalUrl = functions.getUrl();
          const newDimension = getNewLayerDimensions();
          const newLayer = {
            id: Date.now() + index,
            imageUrl: finalUrl,
            backgroundUrl: url,
            functions,
            dimensions: { width: newDimension.width, height: newDimension.height },
            originalDimensions: { width: newDimension.width, height: newDimension.height },
            nonRatioDimensions: { width: newDimension.width, height: newDimension.height },
            adjustments: { ...DEFAULT_ADJUSTMENTS },
            x: 0,
            y: 0,
            nonRatioX: 0,
            nonRatioY: 0,
            zIndex: index + 1,
            backgroundAndResize: {
              removebg: false,
              removebgUrl: "",
              changebg: false,
              changebgUrl: ""
            },
            isResizing: false,
            isRecreated: false,
          };

          return newLayer;
        });

        const addedLayers = await Promise.all(newLayerPromises);

        setLayers(addedLayers);
        initialLayersLoaded.current = true;
        const templateFormat = templateData?.currentFormat;
        let newRatio = 0.56;
        if (templateFormat) {
          const [width, height] = templateFormat.split('x').map(Number);
          const ratio = parseFloat((width / height).toFixed(2));
          newRatio = ratio;
          setSelectedFormats([templateFormat])
        } else {
        }
        prevRatioRef.current = 0.56; //default
        const newEffects = _.cloneDeep(defaultEffects);
        _.set(newEffects, "ratio", newRatio);
        // add presetLayer
        if (isFcbTemplate) {
          // add presetLayer
          addOrUpdatePreset('#363d43');
        }
        setEffects(newEffects)
      }
      initializeLayers();

    }

    form.setFieldsValue({ ...initialValues });
  }, [templateData])

  const addOrUpdateGkPreset = async (gkPresetColor) => {
    const isColorCode = /^#|^rgb|^red$|^black$|^white$/.test(gkPresetColor); // rudimentary check
    if (isColorCode) {
      setEffects({
        ...effects,
        gkPreset: gkPresetColor
      })
    }
    setPresetGkColor(gkPresetColor);
  };

  const setCLStarsOnOrOff = async (value) => {
    setEffects({
      ...effects,
      hasCLStars: value,
    })
  }

  // The DFB Pokal artwork replaces the club background entirely, so it is a
  // plain switch like the CL stars rather than another background layer.
  const setDfbPokalOnOrOff = async (value) => {
    setEffects({
      ...effects,
      isDfbPokal: value,
    })
  }

  const setIncludeSmilingOnOrOff = async (value) => {
    setEffects({
      ...effects,
      includeSmiling: value,
    })
  }

  const setSelectedJersey = async (jersey) => {
    setEffects({
      ...effects,
      jersey: jersey,
    })
  }

  const setSelectedResultTime = async (time) => {
    setEffects({
      ...effects,
      time: time,
    })
  }

  const setSelectedPenalty = async (isPenalty) => {
    setEffects({
      ...effects,
      isPenalty: isPenalty
    })
  }

  // How far the fcb_results bottom scrim reaches up the frame. `commit` is
  // false while the slider handle is being dragged -- every intermediate value
  // would otherwise land in the undo stack -- and true once it is released.
  //
  // updateWithUndo is no use for the committing half: it snapshots `effects` as
  // they are *now*, which by drag-end is already the dragged value, so undo
  // would restore what the user just set. The state from before the drag
  // started is stashed on the first uncommitted call instead, and that is what
  // gets pushed.
  const setScrimHeight = async (height, commit = true) => {
    const updated = { ...effects, scrimHeight: height };

    if (!commit) {
      if (!scrimHeightUndoRef.current) {
        scrimHeightUndoRef.current = {
          layers: _.cloneDeep(layers),
          effects: _.cloneDeep(effects),
        };
      }
      setEffects(updated);
      return;
    }

    const snapshot = scrimHeightUndoRef.current ?? {
      layers: _.cloneDeep(layers),
      effects: _.cloneDeep(effects),
    };
    scrimHeightUndoRef.current = null;

    setHasUnsavedChanges(true);
    setUndoStack((prev) => [...prev, snapshot]);
    setRedoStack([]);
    setUndo(false);
    setEffects(updated);
  }

  const addOrUpdatePreset = async (imageUrl) => {
    const isColorCode = /^#|^rgb|^red$|^black$|^white$/.test(imageUrl); // rudimentary check
    const existingPresetIndex = layers.findIndex(layer => layer.isPreset);
    setPresetBgColor(isColorCode ? imageUrl : "");

    let finalUrl;
    let functions = null;
    if (!isColorCode) {
      functions = new Functions(imageUrl);
      finalUrl = functions.getUrl();
    }
    const newDimension = getNewLayerDimensions();

    const updatedLayer = {
      imageUrl: finalUrl,
      backgroundUrl: imageUrl,
      functions, // Optional, for later use
      dimensions: { width: newDimension.width, height: newDimension.height },
      originalDimensions: { width: newDimension.width, height: newDimension.height },
      nonRatioDimensions: { width: newDimension.width, height: newDimension.height },
      adjustments: { ...DEFAULT_ADJUSTMENTS },
      x: 0,
      y: 0,
      nonRatioX: 0,
      nonRatioY: 0,
      backgroundAndResize: {
        removebg: false,
        removebgUrl: "",
        changebg: false,
        changebgUrl: "",
      },
      isResizing: false,
      isRecreated: true,
      isPreset: true,
      isColor: isColorCode,
    };

    if (existingPresetIndex !== -1) {
      //  Update existing preset layer
      setLayers(prev => {
        const updated = [...prev];
        updated[existingPresetIndex] = {
          ...updated[existingPresetIndex],
          ...updatedLayer, // overwrite only updated fields
        };
        return updated;
      });
    } else {
      //  Add new preset layer
      const maxZ = layers.length > 0 ? Math.max(...layers.map(l => l.zIndex)) : 0;
      const maxI = layers.length > 0 ? Math.max(...layers.map(l => l.id)) : 0;

      const newLayer = {
        ...updatedLayer,
        id: maxI + 1,
        zIndex: maxZ + 1,
      };

      setLayers(prev => [...prev, newLayer]);
    }
  };

  const addLayer = async (imageUrl, removeIndex = null) => {
    const maxZ = layers.length > 0 ? Math.max(...layers.map(l => l.zIndex)) : 0;
    const maxI = layers.length > 0 ? Math.max(...layers.map(l => l.id)) : 0;

    const functions = new Functions(imageUrl);
    const finalUrl = functions.getUrl();
    const newDimension = getNewLayerDimensions();

    const adjustments = removeIndex !== null
      ? layers[removeIndex]?.adjustments
      : layers[currentLayerId]?.adjustments

    const newLayer = {
      id: maxI + 1,
      imageUrl: finalUrl,
      backgroundUrl: imageUrl,
      functions,
      dimensions: { width: newDimension.width, height: newDimension.height },
      originalDimensions: { width: newDimension.width, height: newDimension.height },
      nonRatioDimensions: { width: newDimension.width, height: newDimension.height },
      adjustments,
      x: 0,
      y: 0,
      nonRatioX: 0,
      nonRatioY: 0,
      zIndex: maxZ + 1,
      backgroundAndResize: {
        removebg: false,
        removebgUrl: "",
        changebg: false,
        changebgUrl: "",
      },
      isResizing: false,
      isRecreated: true,
    };

    let updatedLayers;

    if (removeIndex !== null) {
      handleDeleteLayer(
        removeIndex,
        layers,
        currentLayerId,
        setTemplateData,
        setCurrentLayerId,
        updateWithUndo
      );
      await wait(500); // Wait for deletion

      updatedLayers = [...layers, newLayer];
      setLayers(updatedLayers);
      setCurrentLayerId(updatedLayers.length - 1); // Select newly added layer
    } else {
      updatedLayers = [...layers, newLayer];
      setLayers(updatedLayers);
      setCurrentLayerId(updatedLayers.length - 1); //  Select newly added layer
    }
  };

  const moveLayer = (id, direction) => { // direction: up or down
    const idx = layers.findIndex(l => l.id === id);
    const newIdx = direction === 'up' ? idx + 1 : idx - 1;

    if (newIdx < 0 || newIdx >= layers.length) return;

    const reordered = [...layers];
    [reordered[idx], reordered[newIdx]] = [reordered[newIdx], reordered[idx]];

    setLayers(
      reordered.map((layer, index) => ({
        ...layer,
        zIndex: index + 1
      }))
    );
  };

  const trackedFields = ["removebg", "changebg", "ratio"];
  // Reset ref when resetKey changes
  useEffect(() => {
    prevLayerSignatureRef.current = [];
  }, [templateData?.uuid]);
  const getSignature = (layer) => {
    const bg = layer.backgroundAndResize || {};
    const tracked = {};
    trackedFields.forEach((key) => (tracked[key] = bg[key]));
    return JSON.stringify(tracked);
  };

  useEffect(() => {
    // when layers added/removed
    const prevLayers = prevLayersRef.current;
    if (prevLayers.length !== layers.length) {
      prevLayerSignatureRef.current = layers.map((layer) => {
        const signature = getSignature(layer);
        return { id: layer.id, sig: signature };
      });
    }
    prevLayersRef.current = layers;
    const changedLayers = [];
    const currentSignatureMap = layers.map((layer) => {
      const signature = getSignature(layer);
      const prev = prevLayerSignatureRef.current.find((x) => x.id === layer.id)?.sig;
      if (prev && signature !== prev) {
        changedLayers.push({ ...layer, sig: signature });
      }
      return { id: layer.id, sig: signature };
    });

    if (changedLayers.length === 0) return;

    const timeout = setTimeout(() => {
      prevLayerSignatureRef.current = currentSignatureMap;
      onChange(changedLayers, layers);
    }, 200);

    return () => clearTimeout(timeout);
  }, [layers]);

  const onChange = async (changedLayers, allLayers) => {
    if (layersRef.current?.length === 0) return;
    const applyChanges = async () => {
      const updatedLayers = [...allLayers];

      for (let i = 0; i < allLayers.length; i++) {
        const layer = allLayers[i];
        if (!changedLayers.find((l) => l.id === layer.id)) continue;
        let { functions, backgroundUrl } = layer;
        if (!functions || !backgroundUrl) continue;
        functions = new Functions(backgroundUrl);
        let shouldCreateNewLayer = false;
        let newLayerURL = null;
        let removedLayerId = null;

        setIsAPICallCalling(true);
        if (layer.backgroundAndResize.removebg) {
          const { id } = layer;
          removedLayerId = id;
          const returnedUrl = await functionCallback(() => functions.changeBackground(backgroundUrl));
          shouldCreateNewLayer = true;
          // newLayerURL = 'https://cdn.picsart.io/57ca6619-4b6b-4fe2-8447-113bf1b400b9.png?type=PNG&to=max&r=0';
          newLayerURL = returnedUrl;
        } else {
          await functionCallback(() => functions.updateCurrentURL(backgroundUrl));
        }

        if (shouldCreateNewLayer) {
          // download and upload it to our own server for later use
          const uploaded = await uploadMedia({
            uuid: 0,
            data: {
              fileUrls: [newLayerURL]
            },
          })
          const fileUrl = _.get(uploaded, "data.files[0].fullUrl", null);
          if (fileUrl) {
            if (removedLayerId) {
              const index = layers.findIndex(layer => layer.id === removedLayerId);
              await addLayer(fileUrl, index)
            } else {
              await addLayer(fileUrl)
            }
          }
        }

        setIsAPICallCalling(false);
      }
    }
    applyChanges();
  }

  const handleOk = async () => {
    setHasUnsavedChanges(false);
    form.submit();
    setUndoStack([]);
    setRedoStack([]);
    await onClose();

  };


  useEffect(() => {
    if (!backgroundUrls || backgroundUrls.length === 0) return;

    // this is when layer is added/removed
    const syncLayersWithBackgroundUrls = async () => {
      const currentLayers = layersRef.current;
      if (currentLayers.length === 0) {
        if (!initialLayersLoaded.current) return;
      }
      const existingUrls = currentLayers.filter((l) => !l.isRecreated).map((l) => l.backgroundUrl);
      const newUrls = backgroundUrls.filter((url) => !existingUrls.includes(url));
      const removedUrls = existingUrls.filter((url) => !backgroundUrls.includes(url));
      let updatedLayers = [...currentLayers];
      // REMOVE layers
      if (removedUrls.length > 0) {
        updatedLayers = updatedLayers.filter((layer) => {
          const toRemove = removedUrls.includes(layer.backgroundUrl);
          return !toRemove;
        });
      }
      // ADD new layers
      const currentAdjustment = updatedLayers?.[currentLayerId]?.adjustments;
      const newLayerPromises = newUrls.map(async (url, index) => {
        const functions = new Functions(url);
        const finalUrl = functions.getUrl();
        const newDimension = getNewLayerDimensions();
        const newLayer = {
          id: Date.now() + index,
          imageUrl: finalUrl,
          backgroundUrl: url,
          functions,
          dimensions: { width: newDimension.width, height: newDimension.height },
          originalDimensions: { width: newDimension.width, height: newDimension.height },
          nonRatioDimensions: { width: newDimension.width, height: newDimension.height },
          adjustments: currentAdjustment || DEFAULT_ADJUSTMENTS,
          x: 0,
          y: 0,
          nonRatioX: 0,
          nonRatioY: 0,
          zIndex: updatedLayers.length + index + 1,
          backgroundAndResize: {
            removebg: false,
            removebgUrl: "",
            changebg: false,
            changebgUrl: "",
          },
          isResizing: false,
          isRecreated: false,
        };

        return newLayer;
      });

      const addedLayers = await Promise.all(newLayerPromises);
      const finalLayers = [...updatedLayers, ...addedLayers];
      // Only update if changed
      const isDifferent =
        finalLayers.length !== currentLayers.length ||
        finalLayers.some((l, i) => l.backgroundUrl !== currentLayers[i]?.backgroundUrl);

      if (isDifferent) {
        setTimeout(() => {
          setLayers(finalLayers);
          setCurrentLayerId(finalLayers.length - 1); // select newly added layer
        }, 200);
      }
    };

    syncLayersWithBackgroundUrls();
  }, [backgroundUrls]);

  const handleDeleteLayer = (index, layers, currentLayerId, setTemplateData, setCurrentLayerId, updateWithUndo) => {
    setTemplateData((prevTemplateData) => {
      const updatedLayers = [...layers];
      const removedItems = updatedLayers.splice(index, 1);
      const removedItem = removedItems[0];

      const newTempData = _.cloneDeep(prevTemplateData);
      const values = _.get(newTempData, "data.fields[0].value", []);
      if (!removedItem.isRecreated) {
        const newValues = values.filter(v => {
          const fullUrl = v.fullUrl || "";
          const url = v.url || "";
          return (fullUrl !== removedItem?.imageUrl && !removedItem?.imageUrl.includes(url) && (!removedItem.originUrl?.includes(url)));
        });
        _.set(newTempData, "data.fields[0].value", newValues);
        _.set(newTempData, "data.editData.layers", updatedLayers);
      }

      let newCurrentLayerId = currentLayerId;
      if (currentLayerId === index) {
        if (index > 0) {
          newCurrentLayerId = index - 1;
        } else {
          newCurrentLayerId = updatedLayers.length > 0 ? 0 : -1;
        }
      } else if (currentLayerId > index) {
        newCurrentLayerId -= 1;
      }

      setTimeout(() => {
        updateWithUndo(updatedLayers, "adjustments");
      }, 200);

      setCurrentLayerId(newCurrentLayerId);
      return newTempData;
    });
  };
  useEffect(() => {
    return () => {
      resetRefs();
    };
  }, []);
  const changedResize = effects?.resize;
  const resize = changedResize ?? 100;
  const scale = resize / 100;

  const [screenSize, setScreenSize] = useState({ width: MAX_WIDTH, height: MAX_HEIGHT });

  const _ratio = effects?.ratio;
  const _initialFormat = _ratio === 0.8 ? "1200x1500" : _ratio === 1.78 ? "1920x1080" : "1080x1920";
  const [updatedFormat, setUpdatedFormat] = useState(previewFormat || _initialFormat);
  useEffect(() => {
    // prevRatioRef
    if (!effects) return;
    const timeout = setTimeout(() => {
      const scaledDimensions = getWrapperDimensions(effects?.ratio);
      setScreenSize(scaledDimensions);
      const _ratio = effects?.ratio;
      const _initialFormat = _ratio === 0.8 ? "1200x1500" : _ratio === 1.78 ? "1920x1080" : "1080x1920";
      setUpdatedFormat(_initialFormat);
      setLoadingFormat(false);
      if (undo) return;
      if (effects?.ratio !== 0) {
        setSelectedFormats([getFormatFromRatio(effects?.ratio)]);
        const prevRatioValue = prevRatioRef.current;
        if (prevRatioValue !== effects?.ratio) {
          // Ratio changed — handle update logic
          if (prevRatioValue) {
            const scaledDimensions = getWrapperDimensions(effects?.ratio);
            // loop through layers and change sizes
            const updatedLayers = layers?.map((layer) => {
              const nonRatioDimensions = layer.nonRatioDimensions;
              const prevLayerDimension = getWrapperDimensions(prevRatioValue);
              const { width: prevWidth, height: prevHeight } = prevLayerDimension;
              const { width: targetWidth, height: targetHeight } = scaledDimensions;
              const { width: nonRatioWidth, height: nonRatioHeight } = nonRatioDimensions;
              const { width: currentWidth, height: currentHeight } = layer.dimensions;
              const newWidth = nonRatioWidth * (targetWidth / prevWidth);
              const newHeight = nonRatioHeight * (targetHeight / prevHeight);
              const yRatio = newHeight / currentHeight;
              const prevCanvasHeight = targetHeight / yRatio;
              const newY = targetHeight / (prevCanvasHeight / layer.nonRatioY)

              const xRatio = newWidth / currentWidth;
              const prevCavnasWidth = targetWidth / xRatio;
              const newX = targetWidth / (prevCavnasWidth / layer.nonRatioX)
              return {
                ...layer,
                dimensions: {
                  width: Math.round(newWidth),
                  height: Math.round(newHeight),
                },
                nonRatioDimensions: {
                  width: Math.round(newWidth),
                  height: Math.round(newHeight),
                },
                x: newX,
                y: newY,
                nonRatioX: newX,
                nonRatioY: newY,
              };
            });

            setLayers(updatedLayers);
          }

          prevRatioRef.current = effects?.ratio;

        }
      }
    }, 100);
    return () => clearTimeout(timeout);
  }, [effects?.ratio, undo]);

  useEffect(() => {
    if (cropOption === cropButtons[0].label) {
      setCropping(true);
    } else {
      setCropping(false);
    }
    setLoadingFormat(false);
  }, [cropOption])

  const onLayerSelected = (index) => {
    // Swap the imagesS
    const updatedLayersCopy = [...layers]; // copy to avoid direct state mutation
    const lastIndex = updatedLayersCopy.length - 1;
    if (index >= 0 && index < updatedLayersCopy.length) {
      setCurrentLayerId(index);
    }
  }

  const handleChange = (key, value) => {
    const updatedLayers = layers.map((layer, index) =>
      index === currentLayerId
        ? {
          ...layer,
          adjustments: {
            ...layer.adjustments,
            [key]: value,
          },
        }
        : layer
    );
    updateWithUndo(updatedLayers, "adjustments");
  };

  const currentValues = layers[currentLayerId]?.adjustments || {};
  const currentTab = TABS.find((tab) => tab.id === activeRightSideBarTab);

  useEffect(() => {
    setActiveRightSideBarTab("light");
    // setCollapsed({ light: false, effect: true, color: true });
    setVisible({ light: true, effect: true, color: true });

    if (templateData?.template_name === "Result") {
      const updatedLayers = layers.map((layer, index) =>
        index === currentLayerId
          ? {
            ...layer,
            adjustments: {
              ...DEFAULT_ADJUSTMENTS,
              ...layer.adjustments,
            },
          }
          : layer
      );
      updateWithUndo(updatedLayers, "initial-light-defaults");
    }
  }, []);

  const [cropping, setCropping] = useState(false);
  const initialCrop = {
    unit: '%',
    width: 0,
    height: 0,
    x: 0,
    y: 0
  }
  const [crop, setCrop] = useState(initialCrop);

  async function getCroppedImg(id, imageSrc, crop) {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.crossOrigin = "anonymous"; // important if image is remote
      image.src = imageSrc;

      image.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const imgElement = document.getElementById(`${id}-fcb-template-image-for-crop`); // or use ref
        if (!ctx) {
          reject("Canvas not supported");
          return;
        }
        const scaleX = image.naturalWidth / imgElement.clientWidth;
        const scaleY = image.naturalHeight / imgElement.clientHeight;

        const pixelX = crop.x * scaleX;
        const pixelY = crop.y * scaleY;
        const pixelWidth = crop.width * scaleX;
        const pixelHeight = crop.height * scaleY;

        // 👇 use *natural pixel size* for the canvas
        canvas.width = pixelWidth;
        canvas.height = pixelHeight;

        ctx.drawImage(
          image,
          pixelX, pixelY, pixelWidth, pixelHeight,  // source rect (natural px)
          0, 0, pixelWidth, pixelHeight             // destination rect matches canvas size
        );

        resolve(canvas.toDataURL("image/png"));
      };

      image.onerror = (err) => reject(err);
    });
  }

  async function finishCrop(e) {
    e.preventDefault();
    const layer = layers[currentLayerId];
    if (!layer.crop) return;
    if (layer.crop?.width === 0 || layer.crop?.height === 0) return;
    const originUrl = layer.originUrl || layer.imageUrl;
    const croppedDataUrl = await getCroppedImg(layer.id, layer.imageUrl, layer.crop);

    // replace the original imageUrl with cropped one
    setLayers(prev =>
      prev.map((l, i) =>
        i === currentLayerId ? {
          ...l,
          imageUrl: croppedDataUrl,
          originUrl,
          dimensions: {
            width: layer.crop.width,
            height: layer.crop.height
          },
          x: layer.crop.x,
          y: layer.crop.y,
          crop: null,
        } : l
      )
    );

    setCropping(false);
    setCrop(initialCrop);
    setCropOption(cropButtons[1].label)
  }
  return (
    <>
      <Modal
        open={open}
        footer={null}
        closeIcon={false}
        width={isFcbTemplate ? 1200 : "1650px"}
        style={{ top: 30, height: 1200 }}
        bodyStyle={{ padding: 0 }}
        className="image-editor-modal"
        onOk={handleOk}
      >
        <Form form={form} onFinish={onFinish} onValuesChange={onValuesChange}>
          <div className="editor-container">
            {/* Header */}
            <div className="editor-header">
              <h3 className="editor-title">Content Editor</h3>
              <div className="editor-actions">
                <Button
                  type="text"
                  icon={<CloseOutlined />}
                  onClick={handleClose}
                />
              </div>
            </div>

            {/* Main Body */}
            <div className="editor-body">
              {/* Left Sidebar */}
              <LeftSideBar
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                templateData={templateData}
                setTemplateData={setTemplateData}
                originTemplateData={originTemplateData}
                selectedTemplate={selectedTemplate}
                setSelectedTemplate={setSelectedTemplate}
                form={form}
                onValuesChange={onValuesChange}
                backgroundAndResize={layers[currentLayerId]?.backgroundAndResize}
                effects={effects}
                setEffects={setEffects}
                setBackgroundAndResize={updateBackgroundAndResize}
                updateWithUndo={updateWithUndo}
                addOrUpdatePreset={addOrUpdatePreset}
                addOrUpdateGkPreset={addOrUpdateGkPreset}
                setSelectedJersey={setSelectedJersey}
                setSelectedResultTime={setSelectedResultTime}
                setSelectedPenalty={setSelectedPenalty}
                setScrimHeight={setScrimHeight}
                addLayer={addLayer}
                setSelectedRatio={setSelectedRatio}
                isFcbTemplate={isFcbTemplate}
                hasCompetitionToggles={isFcbTemplate || isSlider1 || isSlider2 || isSlider4}
                manualEntries={manualEntries}
                setManualEntries={setManualEntries}
                presetBgColor={presetBgColor}
                presetGkColor={presetGkColor}
                setCLStarsOnOrOff={setCLStarsOnOrOff}
                setDfbPokalOnOrOff={setDfbPokalOnOrOff}
                setIncludeSmilingOnOrOff={setIncludeSmilingOnOrOff}
                cropOption={cropOption}
                setCropOption={setCropOption}
                isUEFAMatch={isUEFAMatch}
              />

              {/* Center Canvas */}
              <div className="editor-canvas">
                <div className="editor-action-div">
                  <div
                    className="editor-actions-left"
                    style={{ marginRight: "auto" }}
                  >
                    {
                      !isFcbTemplate && [
                        <Button
                          type="text"
                          disabled={undoStack.length === 0}
                          onClick={handleUndo}
                        >
                          <UndoOutlined />
                          undo
                        </Button>,
                        <Button
                          type="text"
                          disabled={redoStack.length === 0}
                          onClick={handleRedo}
                        >
                          <RedoOutlined />
                          redo
                        </Button>,
                        <Button
                          type="text"
                          disabled={undoStack.length === 0}
                          onClick={() => handleReset()}
                        >
                          <CloseCircleOutlined />
                          reset
                        </Button>
                      ]
                    }

                  </div>
                  <div className="editor-actions">
                    <Button
                      type="primary"
                      // onClick={handleOk}
                      onClick={() => setShowSaveModal(true)}
                    >
                      Save
                    </Button>
                  </div>
                </div>
                <div className="editor-canvas-preview">
                  <div
                    className="editor-canvas-preview-img"
                    style={{
                      width: screenSize.width,
                      height: screenSize.height,
                    }}
                  >
                    {loading || isAPICallCalling ? (
                      <Spin indicator={<LoadingOutlined spin />} size="large" />
                    ) : (
                      <div
                        className={`editor-canvas-preview-inner ${effects?.ratio === 0.56
                          ? "ratio-9-16"
                          : effects?.ratio === 0.8
                            ? "ratio-4-5"
                            : "ratio-16-9"
                          }`}
                        style={{
                          filter: `
                            ${effects?.isBlur ? "blur(5px)" : ""}
                            ${effects?.isOpacity ? "opacity(0.6)" : ""}
                            ${effects?.isShadow ? "drop-shadow(5px 5px 10px rgba(0,0,0,0.5))" : ""}
                          `,
                          // Slider 2's picture no longer covers the canvas,
                          // so the canvas itself is what shows around it --
                          // white for a white kit, club or competition artwork
                          // otherwise. Resolved by the same helper the template
                          // renders with (MatchdaySlider2/background.js), which
                          // is what keeps this preview and the export in step.
                          background: effects?.isGradient
                            ? "linear-gradient(to bottom right, #e66465, #9198e5)"
                            : isSlider2
                              ? getSlider2Background({
                                jersey: effects?.jersey,
                                hasCLStars: effects?.hasCLStars,
                                isDfbPokal: effects?.isDfbPokal,
                              })
                              : "none",
                          width: "100%",
                          height: "100%",
                          transform: `scale(${scale})`,
                        }}
                      >
                        {/* fcb_results draws its own UEFA gradient inside the scaled
                            template preview, where it stacks against the bottom
                            scrim the same way it does in the export. */}
                        {isFcbTemplate ? (
                          <div
                            className={`comp-template-preview f-${updatedFormat}`}
                          >
                            <div className="template-container">
                              {
                                loadingFormat ? <div>Loading ...</div> : <LineupForEdit
                                  apiSetup={apiSetup}
                                  data={templateData}
                                  presetBgColor={presetBgColor}
                                  manualEntries={manualEntries}
                                  presetGkColor={presetGkColor}
                                  hasCLStars={effects?.hasCLStars}
                                  isDfbPokal={effects?.isDfbPokal}
                                  format={updatedFormat}
                                />
                              }

                            </div>
                          </div>
                        ) : (
                          loadingFormat ? <div> Loading ... </div> : frameLayers(layers?.map((layer, index) => {
                            const filterStyles = getImageFilterStyle(layer.adjustments);
                            let { filter } = filterStyles;
                            // Both matchday sliders paint their layers with no
                            // filter at all -- each template has the whole
                            // `filter` line commented out (see the layer maps in
                            // MatchdaySlider2/Index.jsx and
                            // MatchdaySlider4/Index.jsx), so leaving one here
                            // would preview adjustments -- greyscale included --
                            // that the export never applies.
                            if (isSlider2 || isSlider4) {
                              filter = undefined;
                            }
                            return (
                              <div
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  position: "absolute",
                                }}
                              >
                                <div
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    position: "absolute",
                                    inset: 0,
                                    overflow: "hidden", // keeps image cropped to parent
                                    // This box is already exactly the frame, so
                                    // it is where slider 2's bevel goes: the
                                    // image gets the cut corners while the
                                    // drag handles, which live outside this
                                    // box, stay square and grabbable.
                                    ...(isSlider2
                                      ? { clipPath: getSlider2PictureClip(slider2Scale()) }
                                      : null),
                                  }}
                                >
                                  <Rnd
                                    key={layer.id}
                                    size={{
                                      width: layer.dimensions?.width,
                                      height: layer.dimensions?.height,
                                    }}
                                    position={{
                                      x: layer.x,
                                      y: layer.y,
                                    }}
                                    bounds={false}
                                  >
                                    {/* Background image */}
                                    {
                                      (cropping && currentLayerId === index) ? <ReactCrop crop={crop} onChange={c => setCrop(c)} onComplete={(c) => {
                                        setLayers(prev =>
                                          prev.map((l, i) =>
                                            i === index ? { ...l, crop: c } : l
                                          )
                                        );
                                      }}>
                                        <img
                                          src={layer.imageUrl}
                                          draggable={false}
                                          id={`${layer.id}-fcb-template-image-for-crop`}
                                          style={{
                                            position: 'absolute',
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                            // ...getImageFilterStyle(layer.adjustments),
                                            filter: filter,
                                            border: index === currentLayerId ? "1px solid blue" : "none",
                                            objectPosition: "top"
                                          }}
                                        />
                                      </ReactCrop> :

                                        <img
                                          src={layer.imageUrl}
                                          draggable={false}
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                            filter: filter,
                                            border: index === currentLayerId ? "1px solid blue" : "none",
                                            objectPosition: "top"
                                          }}
                                        />
                                    }



                                    {/* Bottom gradient to emphasize score area.
                                        Not on either matchday slider: slider 2's
                                        picture is a framed box on a light canvas
                                        rather than a full-bleed background with
                                        text over the foot of it, and slider 4
                                        carries its own artwork, so neither
                                        template draws this and darkening them
                                        here would preview a scrim the export
                                        does not have. Not on fcb_results either:
                                        its scrim belongs to the frame, so
                                        FCBResultContent draws it once over the
                                        whole canvas — per-layer copies would
                                        slide with the picture. */}
                                    {!isSlider2 && !isSlider4 && !isResults && (
                                      <div
                                        style={{
                                          position: "absolute",
                                          bottom: 0,
                                          left: 0,
                                          right: 0,
                                          height: "65%", // Adjust as needed
                                          background: "linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(30,30,30,1) 100%)",
                                          pointerEvents: "none",
                                          zIndex: 2,
                                        }}
                                      />
                                    )}

                                    {/* Color overlays */}
                                    {getImageFilterStyle(layer.adjustments).colorOverlays?.map((overlayStyle, index) => (
                                      <div
                                        key={index}
                                        style={{
                                          position: 'absolute',
                                          top: 0,
                                          left: 0,
                                          width: '100%',
                                          height: '100%',
                                          pointerEvents: 'none',
                                          ...overlayStyle,
                                        }}
                                      />
                                    ))}
                                  </Rnd>

                                </div>
                                <Rnd
                                  key={layer.id}
                                  size={{
                                    width: layer.dimensions?.width,
                                    height: layer.dimensions?.height,
                                  }}
                                  style={{
                                    border: '0.5px solid blue',
                                    pointerEvents: `${cropping && index === currentLayerId ? 'none' : 'auto'}`
                                  }}
                                  position={{
                                    x: layer.x,
                                    y: layer.y,
                                  }}
                                  bounds={false}
                                  onClick={() => setCurrentLayerId(index)}
                                  onResize={(e, direction, ref, delta, position) => {
                                    // 🔥 live update while resizing
                                    setLayers((prev) =>
                                      prev.map((l, i) =>
                                        i === index
                                          ? {
                                            ...l,
                                            dimensions: {
                                              width: ref.offsetWidth,
                                              height: ref.offsetHeight,
                                            },
                                            nonRatioDimensions: {
                                              width: ref.offsetWidth,
                                              height: ref.offsetHeight,
                                            },
                                            x: position.x,
                                            y: position.y,
                                            nonRatioX: position.x,
                                            nonRatioY: position.y,
                                          }
                                          : l,
                                      ),
                                    );
                                  }}
                                  onDrag={(e, d) => {
                                    setLayers((prev) =>
                                      prev.map((l, i) =>
                                        i === index
                                          ? {
                                            ...l,
                                            x: d.x,
                                            y: d.y,
                                            nonRatioX: d.x,
                                            nonRatioY: d.y,
                                          }
                                          : l,
                                      ),
                                    );
                                  }}
                                  onDragStop={(e, d) => {
                                    setLayers((prev) =>
                                      prev.map((l, i) =>
                                        i === index
                                          ? {
                                            ...l,
                                            x: d.x,
                                            y: d.y,
                                            nonRatioX: d.x,
                                            nonRatioY: d.y,
                                          }
                                          : l,
                                      ),
                                    );
                                    updateWithUndo();
                                  }}
                                  onResizeStart={() => setCurrentLayerId(index)}
                                  onResizeStop={(
                                    e,
                                    direction,
                                    ref,
                                    delta,
                                    position,
                                  ) => {
                                    setLayers((prev) =>
                                      prev.map((l, i) =>
                                        i === index
                                          ? {
                                            ...l,
                                            dimensions: {
                                              width: ref.offsetWidth,
                                              height: ref.offsetHeight,
                                            },
                                            nonRatioDimensions: {
                                              width: ref.offsetWidth,
                                              height: ref.offsetHeight,
                                            },
                                            x: position.x,
                                            y: position.y,
                                            nonRatioX: position.x,
                                            nonRatioY: position.y,
                                          }
                                          : l,
                                      ),
                                    );
                                    updateWithUndo();
                                  }}
                                  enableResizing={!cropping}
                                  disableDragging={cropping}
                                >
                                </Rnd>
                              </div>
                            );
                          }))
                        )}

                        {selectedTemplate !== "" && (selectedTemplate === "fcb_results" || selectedTemplate === "womens_results" || selectedTemplate === "juniors_results") && (
                          <FCBResultContent data={templateData} manualEntries={manualEntries} time={effects?.time} isPenalty={effects?.isPenalty} ratio={effects?.ratio} hasBackground={layers?.length > 0} scrimHeight={effects?.scrimHeight} />
                        )}

                        {selectedTemplate !== "" && selectedTemplate === "fcb_heatmap" && (
                          <FCBHeatmapContent data={templateData} />
                        )}

                        {selectedTemplate !== "" && selectedTemplate === "fcb_matchday_slider_1" && (
                          <FCBSlider1Content
                            data={templateData}
                            jersey={effects?.jersey}
                            hasCLStars={effects?.hasCLStars}
                            isDfbPokal={effects?.isDfbPokal}
                            ratio={effects?.ratio}
                          />
                        )}
                        {selectedTemplate !== "" && selectedTemplate === "fcb_matchday_slider_2" && (
                          <FCBSlider2Content
                            data={templateData}
                            manualEntries={manualEntries}
                            jersey={effects?.jersey}
                            hasCLStars={effects?.hasCLStars}
                            isDfbPokal={effects?.isDfbPokal}
                            ratio={effects?.ratio}
                          />
                        )}
                        {selectedTemplate !== "" && selectedTemplate === "fcb_matchday_slider_3" && (
                          <FCBSlider3Content data={templateData} jersey={effects?.jersey} ratio={effects?.ratio} />
                        )}
                        {selectedTemplate !== "" && selectedTemplate === "fcb_matchday_slider_4" && (
                          <FCBSlider4Content
                            data={templateData}
                            jersey={effects?.jersey}
                            hasCLStars={effects?.hasCLStars}
                            isDfbPokal={effects?.isDfbPokal}
                            ratio={effects?.ratio}
                          />
                        )}
                        {selectedTemplate !== "" && selectedTemplate === "fcb_goal" && (
                          <FCBGoalContent data={templateData} />
                        )}
                        {selectedTemplate !== "" && selectedTemplate === "fcb_image_table" && (
                          <FCBTableContent data={templateData} customClass={`f-${updatedFormat}`} />
                        )}
                      </div>
                    )}

                  </div>
                  <div className="editor-crop-button">
                    {
                      cropping && <button onClick={finishCrop}>Finish Crop</button>
                    }

                  </div>


                  <div className="editor-canvas-preview-inner">
                    <LayersList
                      layers={layers}
                      setLayers={setLayers}
                      currentLayerId={currentLayerId}
                      setCurrentLayerId={setCurrentLayerId}
                      onLayerSelected={(index) => onLayerSelected(index)}
                      handleDeleteLayer={(index) => {
                        handleDeleteLayer(
                          index,
                          layers,
                          currentLayerId,
                          setTemplateData,
                          setCurrentLayerId,
                          updateWithUndo
                        );
                      }}
                    />
                    <Button onClick={() => setVisibleEdit(true)} disabled={isFcbTemplate}>
                      <PlusOutlined />
                    </Button>
                    {visibleEdit && (
                      <InputSlide
                        hidePreview={true}
                        item={fields[0]?.id === "background" && fields[0]}
                        setVisibleEdit={setVisibleEdit}
                        showPreview={false}
                      />
                    )}
                  </div>
                </div>
              </div>
              {/* Right Sidebar */}
              {(!filteredTemplates.includes(templateData.template_name) && (activeTab !== 'Content')) &&
                <div className="editor-sidebar right">
                  <h4 className="editor-sidebar-title">Adjustment</h4>
                  {/* Put toggler for reverting adjustments */}
                  <div className="adjustment-switch-inner">
                    <span>Default adjustment</span>
                    <Switch
                      size="small"
                      // checked={backgroundAndResize?.removebg}

                      onChange={async (checked) => {
                        const updatedLayers = [...layers];
                        const currentLayer = updatedLayers[currentLayerId];
                        if (checked) {
                          currentLayer.adjustments = INITIAL_ADJUSTMENTS;
                        } else {
                          currentLayer.adjustments = DEFAULT_ADJUSTMENTS;
                        }
                        setLayers(updatedLayers)
                      }}
                    />
                  </div>
                  <div className="adjustment-tab-buttons">
                    {TABS.map((tab) => (
                      <button
                        key={tab.id}
                        className={activeRightSideBarTab === tab.id ? "tab-btn active" : "tab-btn"}
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          setActiveRightSideBarTab(tab.id)
                        }
                        }>
                        {tab.title}
                      </button>
                    ))}
                  </div>

                  {currentTab && (
                    <div className={`adjustment-panel-wrapper ${activeTab}-theme`}>
                      {currentTab.id === "color" ? (
                        <ColorMixerPanel
                          tab={currentTab} // new
                          collapsed={collapsed[activeRightSideBarTab]}
                          visible={visible[activeRightSideBarTab]}
                          toggleCollapse={() =>
                            setCollapsed({ ...collapsed, [activeRightSideBarTab]: !collapsed[activeRightSideBarTab] })
                          }
                          toggleVisible={() =>
                            setVisible({ ...visible, [activeRightSideBarTab]: !visible[activeRightSideBarTab] })
                          }
                          colorMode={colorMode}
                          setColorMode={setColorMode}
                          currentValues={currentValues}
                          onChange={handleChange}
                          isFcbTemplate={isFcbTemplate}
                        />

                      ) : (
                        <AdjustmentPanel
                          tab={currentTab}
                          collapsed={collapsed[activeRightSideBarTab]}
                          visible={visible[activeRightSideBarTab]}
                          toggleCollapse={() =>
                            setCollapsed({ ...collapsed, [activeRightSideBarTab]: !collapsed[activeRightSideBarTab] })
                          }
                          toggleVisible={() =>
                            setVisible({ ...visible, [activeRightSideBarTab]: !visible[activeRightSideBarTab] })
                          }
                          currentValues={currentValues}
                          onChange={handleChange}
                          isFcbTemplate={isFcbTemplate}
                        />
                      )}
                    </div>
                  )}
                </div>
              }
            </div>
          </div>
        </Form>
      </Modal>
      {showSaveModal && (
        <SaveModal
          show={showSaveModal}
          onClose={() => setShowSaveModal(false)}
          handleOk={handleOk}
          backendCfg={backendCfg}
          template={templateData}
          layers={layers}
          effects={effects}
          selectedLangs={selectedLangs}
          setSelectedLangs={setSelectedLangs}
          selectedFormats={selectedFormats}
          setSelectedFormats={setSelectedFormats}
          manualEntries={manualEntries}
          presetBgColor={presetBgColor}
          presetGkColor={presetGkColor}
        />
      )}
    </>
  );
};

export default ImageEditorModal;
